import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';

const SUPPORTED_LANGS = ['fr', 'en', 'es', 'it'];

export const useDocumentLang = () => {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const lang = params.get('lang');
      if (lang && SUPPORTED_LANGS.includes(lang)) {
        i18n.changeLanguage(lang);
        params.delete('lang');
        const newSearch = params.toString();
        const newUrl =
          window.location.pathname +
          (newSearch ? `?${newSearch}` : '') +
          window.location.hash;
        window.history.replaceState({}, '', newUrl);
      }
    } catch {
      // fall back to auto-detection
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = i18nInstance.language || 'fr';
  }, [i18nInstance.language]);
};
